/**
 * TOP リニューアル（2026-07）：全ページ共通スクリプト
 *
 * ヘッダー（スクロール時の面出し）とドロワーの開閉だけを担当する。
 * ヘッダー・フッターは header-group / footer-group 経由で全ページに出るため、
 * このファイルも全ページで読み込む。
 * スライダー・リビール・パララックス等は custom-202607-top.js（index のみ）。
 */

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".c-header");
  const menuButton = document.querySelector(".c-header__menu-button");
  const drawer = document.querySelector(".c-drawer");
  const closeButton = document.querySelector(".c-drawer__close-button");
  /* ロゴも含める。TOPではロゴが同一ページ内アンカー（#top-hero）で遷移が起きないため、
     閉じないとドロワーが画面を覆ったままになり、押しても何も起きないように見える。 */
  const drawerLinks = document.querySelectorAll(".c-drawer__link, .c-drawer__logo-link, .c-drawer__sublink");

  const updateHeader = () => {
    header?.classList.toggle("c-header--scrolled", window.scrollY > 40);
  };

  const setDrawerState = (isOpen) => {
    if (!menuButton || !drawer) {
      return;
    }

    drawer.classList.toggle("c-drawer--open", isOpen);
    drawer.setAttribute("aria-hidden", String(!isOpen));
    menuButton.setAttribute("aria-expanded", String(isOpen));
    menuButton.setAttribute("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");
    document.body.classList.toggle("body--drawer-open", isOpen);

    if (isOpen) {
      closeButton?.focus();
    } else {
      menuButton.focus();
    }
  };

  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });
  menuButton?.addEventListener("click", () => setDrawerState(true));
  closeButton?.addEventListener("click", () => setDrawerState(false));
  drawerLinks.forEach((link) => {
    link.addEventListener("click", () => setDrawerState(false));
  });

  /* ヘッダーのプルダウン
     開閉そのものは CSS の :hover / :focus-within でも成立するが、
     aria-expanded は CSS から動かせないので状態をここで同期する。
     click を拾うのはタッチ環境（hover が無い）で開けるようにするため。 */
  const navToggles = document.querySelectorAll(".c-header__nav-toggle");

  const setSubmenuState = (toggle, isOpen) => {
    toggle.closest(".c-header__nav-item")?.classList.toggle("c-header__nav-item--open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
  };

  const closeAllSubmenus = () => {
    navToggles.forEach((toggle) => setSubmenuState(toggle, false));
  };

  navToggles.forEach((toggle) => {
    const item = toggle.closest(".c-header__nav-item");

    if (!item) {
      return;
    }

    toggle.addEventListener("click", () => {
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      closeAllSubmenus();
      setSubmenuState(toggle, !isOpen);
    });

    /* ナビ項目とメガメニューの間にはヘッダーの下パディングが挟まる。
       そこを横切る一瞬で閉じてしまわないよう、閉じる側だけ遅らせる。 */
    let closeTimer = 0;

    item.addEventListener("mouseenter", () => {
      window.clearTimeout(closeTimer);
      setSubmenuState(toggle, true);
    });

    item.addEventListener("mouseleave", () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => setSubmenuState(toggle, false), 220);
    });
    item.addEventListener("focusin", () => setSubmenuState(toggle, true));
    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) {
        setSubmenuState(toggle, false);
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    if (!event.target.closest(".c-header__nav-item--has-children")) {
      closeAllSubmenus();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return;
    }

    if (drawer?.classList.contains("c-drawer--open")) {
      setDrawerState(false);
      return;
    }

    closeAllSubmenus();
  });
});
